;(function () {
  const splitScreenSlid = () => {
    $('.slideshow-column__section').each(function () {
      if ($(this).hasClass('slider_started')) return
      $(this).addClass('slider_started')

      const id = $(this).attr('id')
      const $section = $(this)
      const box = $section.find('.slideshow-column')

      // ✅ elemento real (evita problemas con selectores múltiples)
      const imageEl =
        $section.find('.slideshow-column__image-slider .slideshow-column__image-swiper').get(0) ||
        $section.find('.slideshow-column__image-slider-2 .slideshow-column__image-swiper').get(0)

      const textEl = $section.find('.slideshow-column__text-swiper').get(0)

      const hasImageSwiper = !!imageEl
      const hasTextSwiper = !!textEl

      if (!hasImageSwiper && !hasTextSwiper) return

      const autoplay = !!box.data('autoplay')
      const stopAutoplay = !!box.data('stop-autoplay')

      const delayMs = Number(box.data('delay')) * 1000
      const speedMs = Number(box.data('speed')) * 1000

      // ✅ CLAVE: para que el total sea “delay configurado”, restamos la transición
      const autoplayDelayMs = Math.max(0, delayMs - speedMs)

      let autoplayParm = {}
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: autoplayDelayMs,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
            waitForTransition: true, // ok, porque ya ajustamos delay
          },
        }
      }

      const swiperParms = {
        parallax: box.data('parallax'),
        effect: box.data('effect'),
        speed: speedMs,
        loop: true,
        centeredSlides: false,
        autoHeight: false,
        calculateHeight: false,
        keyboard: true,
        creativeEffect: {
          prev: { shadow: false, translate: [0, 0, -400] },
          next: { translate: ['100%', 0, 0] },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        flipEffect: { slideShadows: false },
        ...autoplayParm,
      }

      const paginationConfig = {
        el: `#${id} .swiper-pagination`,
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}"><span class="bullet-progress"></span></span>`
        },
      }

      // ✅ progreso debe durar EXACTAMENTE lo configurado (delayMs)
      const setBulletDuration = () => {
        box.css('--bullet-duration', `${delayMs}ms`)
      }
      setBulletDuration()

      // ----------------------------
      // CASO ORIGINAL (2 swipers)
      // ----------------------------
      if (hasTextSwiper && hasImageSwiper) {
        const swiperImg = new Swiper(imageEl, {
          ...swiperParms,
          autoplay: false, // igual que tu original
        })

        const swiperText = new Swiper(textEl, {
          pagination: paginationConfig,
          ...swiperParms,
        })

        swiperImg.controller.control = swiperText
        swiperText.controller.control = swiperImg

        swiperText.on('slideChange', function () {
          setBulletDuration()
        })

        swiperText.on('beforeTransitionStart', function () {
          colorScheme(this)
        })
        swiperText.on('slideChange', function () {
          colorScheme(this)
        })

        function colorScheme(context) {
          const parent = box.find('.slideshow-column-bottom')
          const activeSlide = context.slides[context.activeIndex]
          const scheme = $(activeSlide).data('color-scheme')
          const item = parent[0]
          if (!item || !scheme) return

          for (let className of [...item.classList]) {
            if (/color-background-\d+$/.test(className)) item.classList.remove(className)
          }
          item.classList.add(scheme)
        }

        return
      }

      // ----------------------------
      // CASO NUEVO (solo imágenes)
      // ----------------------------
      if (hasImageSwiper) {
        const swiperSingle = new Swiper(imageEl, {
          pagination: paginationConfig,
          ...swiperParms,
        })

        swiperSingle.on('slideChange', function () {
          setBulletDuration()
        })
      }
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    splitScreenSlid()
    document.addEventListener('shopify:section:load', function () {
      splitScreenSlid()
    })
  })
})()